<template>
    <div
        data-cy="more"
        class="relative text-gray-700"
    >
        <div
            v-if="loading"
            class="py-10 flex items-center justify-center"
        >
            <UILoading class="w-12 h-12" />
        </div>
        <div
            v-else-if="error"
            class="p-4"
        >
            <Error
                :axios-error="error"
            />
        </div>
        <ModuleComponents
            v-else-if="more"
            :modules="more"
        />
    </div>
</template>

<script setup>
    import ModuleComponents from '@/components/ModuleComponents.vue'
    import { useMoreStore } from '@/stores/more'
    import Error from '@/components/ui/Error.vue'
    import { usePlatformAuthStore } from '@/stores/platformAuth'

    const props = defineProps({
        content: Object,
    })

    const platformAuthStore = usePlatformAuthStore()
    const moreStore = useMoreStore()
    const { more } = storeToRefs(moreStore)

    const loading = ref(null)
    const error = ref(null)

    watch(more, () => {
        error.value = null
    })

    const refresh = async () => {
        error.value = null
        loading.value = true
        try {
            await moreStore.load()
        } catch (e) {
            error.value = e
        } finally {
            loading.value = false
        }
    }

    onMounted(() => {
        platformAuthStore.events.on('login', refresh)
        refresh()
    })

    onUnmounted(() => {
        platformAuthStore.events.off('login', refresh)
    })
</script>
